import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { setToken, setUser } from "../lib/auth";
import { toast } from "sonner";
import { Loader2, MonitorDot } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const ClientAuthCallback = () => {
  const nav = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      nav("/mon-compte-client", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(match[1]);
    // Clean the hash early so a refresh doesn't replay the OAuth call
    window.history.replaceState(null, "", "/dashboard");

    (async () => {
      try {
        const res = await api.post("/auth/google/session", { session_id });
        setToken(res.data.token);
        setUser(res.data.user);
        if (res.data.reactivated) {
          toast.success(
            "Bon retour ! Votre compte a été réactivé gratuitement. Votre page et vos factures sont restaurées.",
            { duration: 6000 }
          );
        } else {
          const name = res.data?.user?.google_name || res.data?.user?.email;
          toast.success(`Bienvenue ${name || ""}`);
        }
        nav("/dashboard", { replace: true });
      } catch (e) {
        const msg = e?.response?.data?.detail || "Connexion Google échouée";
        toast.error(typeof msg === "string" ? msg : "Connexion Google échouée", { duration: 8000 });
        nav("/mon-compte-client", { replace: true });
      }
    })();
  }, [nav]);

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center gap-4 px-5" data-testid="client-auth-callback">
      <div className="flex items-center gap-2">
        <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
          <MonitorDot className="w-5 h-5 text-white" strokeWidth={2.25} />
        </div>
        <span className="font-bold text-xl tracking-tight">
          Le Guide des Entrepreneurs
        </span>
      </div>
      <Loader2 className="w-8 h-8 animate-spin text-blue-600 mt-2" />
      <p className="text-sm text-gray-500 uppercase tracking-widest">Connexion à votre espace client…</p>
    </div>
  );
};

export default ClientAuthCallback;
